import Client, {ClientOption} from '../client';

export default {
  // returns list of all the Payment route
  getPaymentUrl: (params: any, options?: ClientOption) =>
    Client('POST', 'pay', params, options),
};
